import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Dropdown, Form } from "semantic-ui-react";
import { t } from "../../constant/translations";

const Hint = styled.p`
  color: rgba(0, 0, 0, 0.45);
  font-size: 0.9em;
  margin-top: 4px;
`;

const TeamMemberDropdownComponent = ({
  users,
  value,
  onChange,
  label,
  hint,
}) => {
  if (!users || users.length <= 1) {
    return null;
  }

  const options = users.map((u) => ({
    key: u.id,
    value: u.id,
    text: u.first_name ? `${u.first_name} ${u.last_name}` : u.email,
    description: u.first_name ? u.email : null,
    searchtext: u.first_name
      ? `${u.first_name} ${u.last_name} ${u.email}`
      : u.email,
  }));

  const searchFilter = (opts, query) => {
    const q = query.toLowerCase();
    return opts.filter((o) => o.searchtext.toLowerCase().includes(q));
  };

  return (
    <Form.Field>
      <label>{label || t("block.facility_manager")}</label>
      <Dropdown
        placeholder={t("block.select_facility_manager")}
        fluid
        search={searchFilter}
        selection
        clearable
        options={options}
        value={value || null}
        onChange={(e, { value: selected }) => onChange(selected || null)}
      />
      {hint !== false && (
        <Hint>{hint || t("block.facility_manager_optional")}</Hint>
      )}
    </Form.Field>
  );
};

function stateToProps(state) {
  return {
    users: (state.user.entities || []).filter((u) => u.is_active),
  };
}

export const TeamMemberDropdown = connect(stateToProps)(
  TeamMemberDropdownComponent
);
